import React, { Component } from 'react';

import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import { Provider, observer } from 'mobx-react';

import membershipStore from '../stores/membershipStore';
import { textStore } from '../stores/textStore';
import DataWrapper from '../views/membership/components/DataWrapper';
import UserSubscriptionsView from '../views/membership/UserSubscriptionsView';
import UserSubscriptionCancellationView from '../views/membership/UserSubscriptionCancellationView';
import UserSubscriptionsChangeView from '../views/membership/UserSubscriptionsChangeView';
import CreditCardChangeView from '../views/membership/CreditCardChangeView';
import SuccessView from '../views/membership/SuccessView';
import ErrorView from '../views/membership/ErrorView';


class MembershipApp extends Component {		
	componentDidMount() {			
		textStore.text = window.tkcWidgetContext.text || {};	
	}		

	/*
	renderAlerts() {			
		if (membershipStore.alerts.length === 0) {			
			return null
		}	
		let alertElements = [];
		membershipStore.alerts.map(alert => {
			let style = 'alert-success';
			if (alert.type === 'error') {
				style = 'alert-danger';
			}
			alertElements.push(
				<div className={'text-center alert ' + style} role="alert" key={alert.message}>
					{alert.message}
				</div>					
			)
		});		
		//membershipStore.alerts.replace([]);
		return (
			<div className="container">
				{alertElements}		
			</div>
		);
	}
	*/

  	render() {  
		const context = window.tkcWidgetContext;
		if (context.targetMembershipSlug) {
			// TODO Redirect to change view.
		}
		return (
			<span>
				<DataWrapper />			
				<Provider membershipStore={membershipStore}>          
					<Router>	
						<Switch>
							<Route exact path="/" component={UserSubscriptionsView} /> 					
							<Route exact path="/:id/cancel" component={UserSubscriptionCancellationView} /> 	
							<Route exact path="/change/:slug" component={UserSubscriptionsChangeView} /> 	
							<Route exact path="/change-cc" component={CreditCardChangeView} /> 	
							<Route exact path="/error" component={ErrorView} /> 	
							{/*<Route exact path="/thank-you" component={SuccessView} />*/}
						</Switch>				                        
					</Router>          
				</Provider>
			</span>
		);
  	}
}

export default observer(MembershipApp);



// WEBPACK FOOTER //
// ./src/apps/MembershipApp.js